import { http } from "@/lib/http";

/**
 * DIY campaign CMS pages (built via the external Campaign Builder tool) —
 * used to populate the campaign filter. `id` is the page slug, which is
 * also the `page` field stored on each form response document.
 */
export function fetchCmsCampaigns() {
  return http
    .get("/api/campaigns/v2/pages")
    .then((res) => res.data?.data ?? []);
}

/** Form responses submitted for a given campaign page slug. */
export function fetchCampaignResponses(page) {
  return http
    .get("/api/campaigns/v2/form-responses", { params: { page } })
    .then((res) => res.data?.data ?? []);
}

/** Delete a single campaign form response by document id. */
export async function deleteCampaignResponse(id) {
  const deleteAttempts = [
    () => http.delete(`/api/campaigns/v2/form-responses/${id}`),
    () => http.delete("/api/campaigns/v2/form-responses", { params: { id } }),
    () => http.post("/api/campaigns/v2/deleteFormResponse", { id }),
    () => http.post("/api/campaigns/v2/deleteFormResponses", { ids: [id] }),
  ];

  let lastNotFoundError;
  for (const attempt of deleteAttempts) {
    try {
      return await attempt();
    } catch (error) {
      if (error?.response?.status !== 404) throw error;
      lastNotFoundError = error;
    }
  }

  throw lastNotFoundError;
}
